import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import './SystemStyles.scss';

function PermissionDeniedPage() {
  const navigate = useNavigate();
  const intl = useIntl();
  const { formatMessage } = intl;
  return (
    <div className="not-found-page-wrapper">
      <div className="not-found-page">
        <div className="not-found-block-wrapper">
          <div className="not-found-block-border">
            <div className="not-found-block">
              <div className="text-1">403</div>
              <div className="text-2">{formatMessage({ id: 'permission.access.denied.page' })}</div>
              <div className="text-3">
                <Button className="big" onClick={() => { navigate(window.baseRoute || '/'); }}>
                  {formatMessage({ id: 'back.to.main' })}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PermissionDeniedPage;
